module.exports = __webpack_public_path__ + "img/C05TechSpearmanChampion_ua.0a727689.webp";